import React, {Fragment, useState, useEffect} from 'react';
import Draggable from 'react-draggable';
import {Form, Col} from 'react-bootstrap';

const ImageUpload = (props) => {
        const [selectedFile, setSelectedFile] = useState()
        const [preview, setPreview] = useState()
    
        // create a preview as a side effect, whenever selected file is changed
        useEffect(() => {
            if (!selectedFile) {
                setPreview(undefined)
                return
            }
    
            const objectUrl = URL.createObjectURL(selectedFile)
            setPreview(objectUrl);
            props.settingImage(objectUrl)
    
            // free memory when ever this component is unmounted
            return () => URL.revokeObjectURL(objectUrl)
        }, [selectedFile])
    
        const onSelectFile = e => {
            if (!e.target.files || e.target.files.length === 0) {
                setSelectedFile(undefined)
                return
            }
    
            // I've kept this example simple by using the first image instead of multiple
            setSelectedFile(e.target.files[0])
        }
    
        return (
            <div style={{display: props.display, borderTop: "1px solid #ced4da"}}>
                <label class="btn btn-primary" htmlFor={`file-selector${props.num}`} style={{marginTop: "16px"}}>
                <input type='file' accept='.png' id={`file-selector${props.num}`} onChange={onSelectFile} style={{marginTop: "16px", display:"none"}}/>
                Add Image
                </label>
                {selectedFile ?  
                <Fragment>
                    <Draggable>
                        <img src={preview} height={`${props.height}px`} width={`${props.width}px`}/> 
                    </Draggable>
                    <Form.Row>
                        <Form.Group as={Col} sm="12" md="6" lg="6">
                            <Form.Label>Width in Pixels</Form.Label>
                            <Form.Control type="text" id="label" name="label" value={props.width} onChange={(e) => props.settingWidth(e.target.value)} />
                        </Form.Group>
                        <Form.Group as={Col} sm="12" md="6" lg="6">
                            <Form.Label>Height in Pixels</Form.Label>
                            <Form.Control type="text" id="label" name="label" value={props.height} onChange={(e) => props.settingHeight(e.target.value)}/>
                        </Form.Group>
                    </Form.Row>
                </Fragment>: "" }
            </div>
        )
    }

    export default ImageUpload;